import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import MetaPixelGql from '@/extensions/marketing/store/graphql/queries/MetaPixel.gql';
import SaveMetaPixelGql from '@/extensions/marketing/store/graphql/mutations/SaveMetaPixel.gql';

export default {
    fetch: (cmsId) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: MetaPixelGql,
                    variables: { cms_id: parseInt(cmsId) },
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => resolve(data.EX_MARKETING_MetaPixel))
                .catch(err => reject(err));
        }),

    save: (metaPixel) => {
        metaPixel = _.removeDeepByKey(metaPixel, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveMetaPixelGql,
                    variables: { metaPixel },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_MARKETING_SaveMetaPixel);
                })
                .catch(err => reject(err));
        });
    },
};
